import { ThemeOptions, createTheme } from "@mui/material";
import { esES } from '@mui/material/locale';

const primary = "#88969f";
const secondary = "#fff";

const myFontFamily = [
  'ui-rounded',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
];

const disabledColor = '#000000c9 !important';
const darkModeText = '#ffffff !important';

const components: ThemeOptions["components"] = {
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiInputBase-root .Mui-disabled': {
          WebkitTextFillColor: disabledColor,
        },
      },
    },
    variants: [
      {
        props: { variant: 'standard' },
        style: {},
      },
    ],
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        backgroundColor: '#f4f6f8',
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      root: {
        '& .Mui-disabled': {
          WebkitTextFillColor: disabledColor,
        },
      },
    },
  },
  MuiAutocomplete: {
    variants: [
      {
        props: { noOptionsText: 'No hay opciones' },
        style: {
          '& .MuiAutocomplete-noOptions': {
            color: '#000',
          },
          root: {
            '& .Mui-disabled': {
              WebkitTextFillColor: disabledColor,
            },
          },
        },
      },
    ],
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: primary,
    },
    secondary: {
      main: secondary,
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
  },
  components: components,
  typography: {
    fontFamily: myFontFamily.join(','),
  },
}, esES);

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: primary,
    },
    background: {
      paper: "#272727",
    },
  },
  typography: {
    fontFamily: myFontFamily.join(','),
  },
  components: {
    ...components,
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root .Mui-disabled': {
            WebkitTextFillColor: darkModeText,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root .Mui-disabled': {
            WebkitTextFillColor: darkModeText,
          },
        },
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root .Mui-disabled': {
            WebkitTextFillColor: darkModeText,
          },
        },
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          backgroundColor: '##ced4d7 !important',
          color: '#fff !important',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#232323',
        },
      },
    },
  },
}, esES);

declare module '@mui/material/styles' {
  interface Components {
    [key: string]: any;
  }
}